export const UPDATE_USER_OBJECT = 'UPDATE_USER_OBJECT';
export const UPDATE_USERS_LIST = 'UPDATE_USERS_LIST';
export const UPDATE_USERS_TAB_LIST = 'UPDATE_USERS_TAB_LIST';
export const UPDATE_DASHBOARD_USERS_LIST = 'UPDATE_DASHBOARD_USERS_LIST';

export const UPDATE_UNIT_AND_ACCESSPOINT_USERS_LIST =
  'UPDATE_UNIT_AND_ACCESSPOINT_USERS_LIST';
export const UPDATE_USER = 'UPDATE_USER';
export const LOGOUT = 'LOGOUT';
export const UPDATE_REGISTRAION_USER = 'UPDATE_REGISTRAION_USER';
export const RESET_REGISTRATION = 'RESET_REGISTRATION';
export const UPDATE_VERIFICATION = 'UPDATE_VERIFICATION';
export const UPDATE_REG_STEP = 'UPDATE_REG_STEP';
export const UPDATE_PROFILE_DATA = 'UPDATE_PROFILE_DATA';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const UPDATE_FORGOT_PASSWORD_FLOW = 'UPDATE_FORGOT_PASSWORD_FLOW';
export const UPDATE_CORRELAION_ID = 'UPDATE_CORRELAION_ID';
export const UPDATE_HOMES = 'UPDATE_HOMES';
export const UPDATE_USER_BRAND = 'UPDATE_USER_BRAND';
export const UPDATE_LOCKS = 'UPDATE_LOCKS';
export const ADD_ERROR_MESSAGE = 'ADD_ERROR_MESSAGE';
export const ADD_SUCCESS_MESSAGE = 'ADD_SUCCESS_MESSAGE';
export const LAST_ACTIVITY_TIME = 'LAST_ACTIVITY_TIME';
export const WHITE_LIST_CHECKED = 'WHITE_LIST_CHECKED';
export const USER_VIEW_TYPE = 'USER_VIEW_TYPE';
export const USER_MODAL_VIEW_TYPE = 'USER_MODAL_VIEW_TYPE';
export const USER_SELECTED_HOME = 'USER_SELECTED_HOME';
export const UPDATE_HEADER_STATE = 'UPDATE_HEADER_STATE';
export const UPDATE_SHARED_DATA = 'UPDATE_SHARED_DATA';
export const UPDATE_SITES = 'UPDATE_SITES';
export const UPDATE_BUILDINGS = 'UPDATE_BUILDINGS';
export const UPDATE_FLOORS = 'UPDATE_FLOORS';
export const UPDATE_IS_LOGGED_IN = 'UPDATE_IS_LOGGED_IN';
export const UPDATE_DEVICE_LIST = 'UPDATE_DEVICE_LIST';
export const UPDATE_PARTNER_DEVICE_LIST = 'UPDATE_PARTNER_DEVICE_LIST';
export const UPDATE_ACCESSPOINT_ACTIVITIES = 'UPDATE_ACCESSPOINT_ACTIVITIES';
export const UPDATE_BUILDING_ACTIVITIES = 'UPDATE_BUILDING_ACTIVITIES';
export const PREPEND_BUILDING_ACTIVITIES = 'PREPEND_BUILDING_ACTIVITIES';
export const CLEAR_BUILDING_ACTIVITIES = 'CLEAR_BUILDING_ACTIVITIES';
export const PREPEND_ACCESSPOINT_ACTIVITIES = 'PREPEND_ACCESSPOINT_ACTIVITIES';
export const UPDATE_UNIT_ACTIVITIES = 'UPDATE_UNIT_ACTIVITIES';
export const UPDATE_UNIT_FILTER_ACTIVITIES = 'UPDATE_UNIT_FILTER_ACTIVITIES';
export const PREPEND_UNIT_ACTIVITIES = 'PREPEND_UNIT_ACTIVITIES';
export const PREPEND_UNIT_FILTER_ACTIVITIES = 'PREPEND_UNIT_FILTER_ACTIVITIES';
export const UPDATE_DASHBOARD_ACTIVITIES = 'UPDATE_DASHBOARD_ACTIVITIES';
export const UPDATE_ACTIVE_ISSUES = 'UPDATE_ACTIVE_ISSUES';
export const PREPEND_USER_TAB_LIST = 'PREPEND_USER_TAB_LIST';
export const PREPEND_USER_LIST = 'PREPEND_USER_LIST';
export const UPDATE_REMEMBER_ME = 'UPDATE_REMEMBER_ME';
export const UPDATE_USER_ACTIVITIES = 'UPDATE_USER_ACTIVITIES';
export const CLEAR_USER_ACTIVITIES = 'CLEAR_USER_ACTIVITIES';
export const PREPEND_USER_ACTIVITIES = 'PREPEND_USER_ACTIVITIES';
export const UPDATE_USER_LANGUAGE = 'UPDATE_USER_LANGUAGE';
